/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IMonitoringRoom {
        href: string;
        name: string;
        creationDate: Date;
        monitors: IMonitor[];
        defaultForOrganizationId: number;
        alias: string;
    }

    export interface IHttpMonitorsResponse {
        data?: MonitorVideoStream[];
    }

    export class MonitoringRoom implements IMonitoringRoom {
        public name: string;
        public href: string;
        public creationDate: Date;
        public monitors: IMonitor[];
        public defaultForOrganizationId: number;
        public alias: string;

        public static Empty(): MonitoringRoom {
            return new MonitoringRoom();
        }

        constructor() {
            // empty constructor
            this.name = '';
            this.monitors = undefined;
            this.defaultForOrganizationId = undefined;
            this.alias = '';
        }
    }
}